import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=48ab180c&scoped=true"
import script from "./Quiz.vue?vue&type=script&lang=js"
export * from "./Quiz.vue?vue&type=script&lang=js"
import style0 from "./Quiz.vue?vue&type=style&index=0&id=48ab180c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ab180c",
  null
  
)

export default component.exports